import isEmpty from 'lodash/isEmpty';

export const argumentsToQuery = (params: Record<string, unknown> = {}) => {
  if (isEmpty(params)) {
    return null;
  }

  let queryString = '';
  for (const key in params) {
    const value = params[key];
    if (value === undefined || value === null) {
      continue;
    }
    queryString += `${key}=${value}&`;
  }

  return queryString.slice(0, -1);
};

